angular.module('tf.models')

    .factory("User",function(){

        var user = function User(data) {
            this.loadData(data);
        };


        user.prototype = {
            loadData: function (data) {
                angular.extend(this, data);
            },
            getId : function(){return this.id || this._id;},
            getName : function(){return this.name;},
            getFullName : function(){
                var fullName = "";
                if(this.local) {
                    if(this.local.first_name) {
                        fullName += this.local.first_name;
                        fullName += (this.local.last_name ? (" " + this.local.last_name) : "");
                    } else {
                        return this.getEmail();
                    }
                }
                return fullName;
            },
            getEmail : function () {
                if(this.local){
                    return this.local.email;
                }
            },
            getFarm : function() {
                if(this.farms && this.farms.length) {
                    return this.farms[0];
                }
            },
            getAllFarms : function() {
                if(this.farms && this.farms.length) {
                    return this.farms;
                }
            },
            isSubscribed : function(){
                if(this.isPayAsYouGoPlan()){
                    return farm.billing && farm.billing.is_subscribed;
                }
                return true;
            },
            isFarmOwner : function(){
                var ownerId = this.getFarm().farm.owner.id? this.getFarm().farm.owner.id : this.getFarm().farm.owner;
                return ownerId === this.getId();
            },
            isPayAsYouGoPlan : function () {
                var farm = this.getFarm().farm;
                return farm.plan.code === 400;
            }
        };

        return user;

    })

;
